var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"loader-v2 loader--v2\">\n<div class=\"loader-v2__spinner spinner\">\n<svg class=\"spinner__circular\" viewbox=\"25 25 50 50\">\n<circle class=\"spinner__path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/>\n</svg>\n</div>\n</div>";
var id1="public-booking/loader/v2/loader.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/loader/v2/loader.html
// module id = 1226
// module chunks = 0